<template>
    <router-view />
</template>
<script setup>
import { ref } from "vue";
import { ElDialog, ElTreeSelect, ElButton } from "element-plus";
import { ElMessage, ElMessageBox } from "element-plus";
import { getdeparmentlist, joinlistAPI } from "@/api/api";
const dialogTableVisible = ref(false);
const selectvalue = ref("");
const data = ref([]);
// const getlist = () => {
//     getdeparmentlist().then((res) => {
//         data.value = res.data;
//     });
// };
const defaultProps = ref({
    children: "children",
    label: "name",
    value: "id"
});
// getlist();
const selectchange = () => {
    const formData = new FormData();
    formData.append("id", selectvalue.value);
    joinlistAPI(formData).then((res) => {
        if (res.code === "8200") {
            ElMessage({
                type: "success",
                message: "success"
            });
        }
    });
};

const debounce = (fn, delay) => {
    let timer;
    return (...args) => {
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            fn(...args);
        }, delay);
    };
};

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
    constructor(callback) {
        callback = debounce(callback, 200);
        super(callback);
    }
};
</script>
<style>
.selectdiv {
    height: 400px;
}

#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100%;
}

nav {
    padding: 30px;
}

nav a {
    font-weight: bold;
    color: #2c3e50;
}

nav a.router-link-exact-active {
    color: #42b983;
}
</style>
